/**
 * Environment Configuration for MKM Tour Admin Panel
 * Centralized configuration management for environment variables
 */

const config = {
  // API Configuration
  // Set REACT_APP_API_BASE_URL and REACT_APP_ADMIN_API_BASE_URL in your .env file.
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api/v1',

  ADMIN_API_BASE_URL: process.env.REACT_APP_ADMIN_API_BASE_URL || 'http://localhost:3000/api/v1/admin',

  // Admin Credentials (Development only)
  ADMIN_DEFAULT_EMAIL: process.env.REACT_APP_ADMIN_DEFAULT_EMAIL || 'admin@mkmtour.com',
  ADMIN_DEFAULT_PASSWORD: process.env.REACT_APP_ADMIN_DEFAULT_PASSWORD || 'MKM@Admin2025!',

  // Application Settings
  SITE_NAME: process.env.REACT_APP_SITE_NAME || 'MKM Tour Admin Panel',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development',

  // Feature Flags
  ENABLE_DEBUG: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  ENABLE_MOCK_DATA: process.env.REACT_APP_ENABLE_MOCK_DATA === 'true',

  // Theme Configuration
  THEME: process.env.REACT_APP_THEME || 'light',
  PRIMARY_COLOR: process.env.REACT_APP_PRIMARY_COLOR || '#1976d2',
  SECONDARY_COLOR: process.env.REACT_APP_SECONDARY_COLOR || '#dc004e',

  // Helper methods
  isDevelopment: () => config.ENVIRONMENT === 'development',
  isProduction: () => config.ENVIRONMENT === 'production',
  isDebugMode: () => config.ENABLE_DEBUG && config.isDevelopment(),
  
  // Get full API URL for a specific endpoint
  getApiUrl: (endpoint) => `${config.API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`,
  getAdminApiUrl: (endpoint) => `${config.ADMIN_API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`,

  // Validation
  validate: () => {
    const required = ['API_BASE_URL', 'ADMIN_API_BASE_URL'];
    const missing = required.filter(key => !config[key]);
    
    if (missing.length > 0) {
      console.error('❌ Missing required environment variables:', missing);
      return false;
    }
    
    if (config.isProduction() && (
      config.ADMIN_DEFAULT_EMAIL?.includes('example') || 
      config.ADMIN_DEFAULT_PASSWORD?.includes('2024')
    )) {
      console.warn('⚠️ Default admin credentials detected in production environment!');
    }
    
    return true;
  }
};

// Validate configuration on load
if (!config.validate()) {
  throw new Error('Invalid environment configuration');
}

// Log configuration in development
if (config.isDevelopment() && config.isDebugMode()) {
  console.log('🔧 Admin Panel Configuration:', {
    API_BASE_URL: config.API_BASE_URL,
    ADMIN_API_BASE_URL: config.ADMIN_API_BASE_URL,
    ENVIRONMENT: config.ENVIRONMENT,
    VERSION: config.VERSION,
    THEME: config.THEME
  });
}

export default config;